import { styled } from "goober";
import { mobile } from "clutch/src/Style/style.mjs";

import { CONTENT_HEADER_Z_INDEX } from "@/app/constants.mjs";

export const Outer = styled("header")`
  position: sticky;
  display: flex;
  top: 0;
  transition: background-color var(--transition);
  z-index: ${CONTENT_HEADER_Z_INDEX};
  user-select: none;

  .content-header-middle {
    flex: 1;
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
    margin-inline: auto;
    padding-block: var(--center-padd);
    border-bottom: 1px solid var(--shade3-15);
  }

  .page-info {
    display: flex;
    align-items: center;
    gap: var(--sp-2_5);
  }

  .image {
    width: var(--sp-6_5);
    height: var(--sp-6_5);
    border-radius: 50%;
    overflow: hidden;
  }

  .hidden {
    transition:
      opacity var(--transition),
      transform var(--transition);
    transition-delay: 75ms;
    transform: translateY(0);
  }

  .hidden.from {
    opacity: 0;
    transform: translateY(0.5rem);
  }
  .hidden.leave {
    position: absolute;
    top: var(--offset-top);
    left: var(--offset-left);
  }

  .content-header-backdrop::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: var(--height, 0px);
    background-color: var(--shade9);
    will-change: height;
    transition: height var(--transition-short);
    box-shadow: 0 0 20px var(--shade10);
  }
`;

export const MobileWrapper = styled("div")`
  display: none;

  min-width: var(--sp-6);

  color: var(--shade0-25);

  cursor: pointer;

  z-index: 0; /* they do not show without this ig */

  transition: var(--transition);

  ${mobile} {
    display: initial;
  }

  &:hover {
    color: var(--shade0-75);
  }
`;
